const TEMPLATE_GROUP_TYPE_NAMES = {
  starringYouGif: "Starring You Gif",
  straightUpEcard: "Straight Up Ecard",
  starringYouEcard: "Starring You Ecard",
  starringYouClip: "Starring You Clip",
  starringYouVertical: "Starring You Vertical",
  starringYouInvite: "Starring You Invite",
  starringYouInviteGif: "Starring You Invite Gif",
  starringYouAI: "Morphable Pack Group",
};

const TEMPLATE_GROUP_TYPES = {
  straightUpEcard: "straight_up",
  starringYouEcard: "starring_you",
  starringYouClip: "starring_you_clip",
  starringYouVertical: "starring_you_vertical",
  starringYouInvite: "starring_you_invite",
  starringYouInviteGif: "starring_you_invite_gif",
  starringYouAI: "morphable_pack_group",
  customContentType: "custom_content_type",
};

const TEMPLATE_GROUP_STATUS = {
  live: "Live",
  hidden: "Hidden",
  deleted: "Deleted",
};

const TEMPLATE_STATUS = {
  live: "Live",
  hidden: "Hidden",
  deleted: "Deleted",
};

export const DeviceType = Object.freeze({
  Horizontal: "Horizontal",
  Vertical: "Vertical",
});

export const TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO = Object.freeze({
  [TEMPLATE_GROUP_TYPES.starringYouEcard]: "2/3",
  [TEMPLATE_GROUP_TYPES.starringYouClip]: "4/3",
  [TEMPLATE_GROUP_TYPES.straightUpEcard]: "4/3",
  [TEMPLATE_GROUP_TYPES.starringYouVertical]: "2/3",
  [TEMPLATE_GROUP_TYPES.starringYouInvite]: "2/3",
  [TEMPLATE_GROUP_TYPES.starringYouInviteGif]: "2/3",
  [TEMPLATE_GROUP_TYPES.starringYouAI]: "3/4",
});

export const DeviceTypeToTemplateGroupType = Object.freeze({
  [TEMPLATE_GROUP_TYPES.starringYouEcard]: DeviceType.Horizontal,
  [TEMPLATE_GROUP_TYPES.starringYouClip]: DeviceType.Horizontal,
  [TEMPLATE_GROUP_TYPES.straightUpEcard]: DeviceType.Horizontal,
  [TEMPLATE_GROUP_TYPES.starringYouVertical]: DeviceType.Vertical,
  [TEMPLATE_GROUP_TYPES.starringYouInvite]: null,
  [TEMPLATE_GROUP_TYPES.starringYouInviteGif]: null,
  [TEMPLATE_GROUP_TYPES.starringYouAI]: null,
});

Object.freeze(TEMPLATE_GROUP_TYPE_NAMES);
Object.freeze(TEMPLATE_GROUP_TYPES);
Object.freeze(TEMPLATE_GROUP_STATUS);
Object.freeze(TEMPLATE_STATUS);

export { TEMPLATE_GROUP_TYPE_NAMES, TEMPLATE_GROUP_TYPES, TEMPLATE_GROUP_STATUS, TEMPLATE_STATUS };
